import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class GraphEdgeFilterData {
    graphEdges: Array<DropdownOptionIntegerId>;
    sourceVertices: Array<DropdownOptionIntegerId>;    
    targetVertices: Array<DropdownOptionIntegerId>;
}